import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CountriesEffects } from './effects/countries.effects';
import countriesReducer, { name as countriesFeatureName } from './features/countries.slice';
import { COUNTRIES_CONFIG, COUNTRIES_CONSTANTS } from './countries.config';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(countriesFeatureName, countriesReducer),
    EffectsModule.forFeature([CountriesEffects])
  ],
  providers: [{ provide: COUNTRIES_CONFIG, useValue: COUNTRIES_CONSTANTS }]
})
export class CountriesModule {}
